import {translate} from "@/services/translation/translation";


declare let buildingStates;
export const getBuildingStates = () => {
    if (typeof buildingStates != "undefined"){
        let tempArray :any = new Array();
        let filter_all = {};
        filter_all['id'] = 0;
        filter_all['name'] = translate("products_filter_all");
        $.each(buildingStates, (index, value)=>{
            let tempt = {};
            tempt['id'] = index;
            tempt['name'] = value;
            tempArray.push(tempt);
        });
        tempArray.unshift(filter_all);
        return tempArray;
    }else{
        return [];
    }
};


declare let buildingTypes;
export const getBuildingTypes = () => {
    if (typeof buildingTypes != "undefined"){
        let tempArray :any = new Array();
        let filter_all = {};
        filter_all['id'] = 0;
        filter_all['name'] = translate("products_filter_all");
        $.each(buildingTypes, (index, value)=>{
            let tempt = {};
            tempt['id'] = index;
            tempt['name'] = value;
            tempArray.push(tempt);
        });
        tempArray.unshift(filter_all);
        return tempArray;
    }else{
        return [];
    }
};


declare let categories;
export const getCategories = () => {
    if (typeof categories != "undefined"){
        let newCategories :any = new Array();
        let filter_all = {};
        filter_all['id'] = 0;
        filter_all['name'] = translate("products_filter_all");
        $.each(categories, (index, c)=>{
            let categoryTempt = {};
            categoryTempt['id'] = index;
            categoryTempt['name'] = c;
            newCategories.push(categoryTempt);
        });
        newCategories.unshift(filter_all);
        //console.log(newCategories);
        return newCategories;
    }else{
        let filter_all = {};
        filter_all['id'] = 0;
        filter_all['name'] = translate("products_filter_all");
        return [filter_all];
    }
};

declare let currentDomain;
export const getCurrentDomain = () => {
    if (typeof currentDomain != "undefined" && currentDomain.country_code != 'com'){
        return currentDomain.country_code;
    }else{
        return 0;
    }
};


declare let countryTranslations;
declare let availableCountries;

export const getCountryTranslations = () => {
    if (typeof countryTranslations != "undefined" && typeof availableCountries != "undefined"){

        let newCountryTrans :any = new Array();

        let filter_all = {};
        filter_all['id'] = 0;
        filter_all['name'] = translate("products_filter_all");

        $.each(availableCountries, (index, c)=>{
            let countryTempt = {};
            countryTempt['id'] = index;
            countryTempt['name'] = c;
            newCountryTrans.push(countryTempt);
        });
        newCountryTrans.unshift(filter_all);

        return newCountryTrans;
    }else{
        return [{id: '', name:''}];
    }
};

